<template>
  <div
    @click="onAddQuestion"
    class="rounded-lg border p-6 pt-8 bg-orange-100 text-orange-800 border-orange-300 hover:border-orange-600 aspect-square cursor-pointer flex flex-col flex-1 justify-start items-center gap-4"
  >
    <div class="w-10 h-10 flex items-center justify-center rounded-lg border bg-orange-200 border-orange-300">
      <BoltIcon class="w-6 h-6" />
    </div>
    <div class="flex flex-col gap-2 text-center">
      <span class="text-base font-normal">
        {{ t('slides_editor.components.spark_form.add_spark_question') }}
      </span>
    </div>
  </div>
</template>

<script setup>
import { inject, ref } from 'vue'
import { useBlockUpdate, useSidePanelHelpers, useQuestionHelpers } from '@/features/slides_editor/composables'
import { BoltIcon } from '@heroicons/vue/24/outline'
import { t } from '@/libs/i18n'

const props = defineProps({
  block: {
    type: Object,
    required: true
  }
})

const currentSlide = inject('currentSlide')
const selectedSpark = ref(props?.block?.section?.spark?.id)
const { onBlockUpdate } = useBlockUpdate(props.block, { showErrorStatus: false })
const { replaceInStack, popFromStack, pushToStack } = useSidePanelHelpers()
const { hydrateNewQuestion } = useQuestionHelpers()

const submitForm = async () => {
  const sectionParams = {
    id: props.block.section.id,
    section_spark_attributes: {
      spark_id: selectedSpark.value
    }
  }

  await onBlockUpdate(sectionParams, 'section_attributes')

  popFromStack()
  replaceInStack({
    fixed: true,
    content: {
      component: 'SparkForm',
      title: t('slides_editor.components.spark_form.edit_spark'),
      props: { block: props.block }
    }
  })
}

const onAddQuestion = () => {
  // We need this because the block in the props somehow is not the same as the block in the currentSlide
  const block = currentSlide.value.blocks.find(block => block.block_type === 'section')
  const position = (block.section.spark?.questions?.length || 0) + 1

  const newQuestion = {
    ...hydrateNewQuestion(
      'quiz',
      block,
      {
        position: position,
      }
    )
  }

  if (!block.section.spark) {
    block.section.spark = {}
  }

  if (!block.section.spark.questions) {
    block.section.spark.questions = []
  }

  block.section.spark.questions.push(newQuestion)

  setTimeout(() => {
    const container = document.querySelector('.present [data-scrollable-container]')
    container.scrollTop = container.scrollHeight
  }, 100)

  pushToStack({
    content: {
      component: 'SparkQuestionForm',
      title: t('slides_editor.components.spark_question.question_header', { position }),
      props: {
        question: newQuestion,
        block: block,
        isNew: true
      }
    }
  })
}
</script>

<style>
  textarea {
    field-sizing: content;
  }
</style>
